import React, { useState } from 'react';
import { Tabs } from '@ampol/design-system';
import InvoicesListPage from 'features/invoices/pages/invoices-list-page';
import ReportsSchedule from 'features/reports/pages/reports-schedule/reports-schedule';
import PageHeader from 'components/layout/page-header/page-header';
import { AccessVerifier } from 'utilities/access-verifier';
import { userActionTypes } from 'utilities/user-utilities';
import ViewReports from '../view-reports/view-reports';

/**
 * Reports list scheduling new report
 * @returns JSX Element
 */
const Reports = () => {
  const ReportsTabs = [
    {
      id: 'schedule',
      label: 'Reports schedule',
      hasAccess: AccessVerifier(['card'], [userActionTypes.ReportsRead]),
      children: <ReportsSchedule />
    },
    {
      id: 'view',
      label: 'View reports',
      hasAccess: AccessVerifier(['card'], [userActionTypes.ReportsRead]),
      children: <ViewReports />
    },
    {
      id: 'transfers',
      label: 'Invoices/Statements',
      hasAccess: AccessVerifier(['card', 'cash'], [userActionTypes.ReportsRead]),
      children: <InvoicesListPage />
    },
  ];
  const [defaultTab, setDefaultTab] = useState(ReportsTabs[0]);

  return <div className={'reports-list-page'}>
    <PageHeader title='Reports' />
    <Tabs items={ReportsTabs} currentTab={defaultTab} onTabSelected={setDefaultTab} />
  </div>;
};

export default Reports;
